import { ExpandMore as ExpandMoreIcon } from '@mui/icons-material';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Typography,
} from '@mui/material';
import React from 'react';

type Props = {
  title: string;
  defaultExpanded?: boolean;
  children: React.ReactNode;
};

export const ManageShopAccordion: React.FC<Props> = ({
  title,
  defaultExpanded,
  children,
}) => (
  <Accordion
    defaultExpanded={defaultExpanded}
    sx={{
      mb: 2,
      borderRadius: 2,
      bgcolor: 'background.default',
      '&:before': { display: 'none' },
      '&.Mui-expanded': { margin: 0, mb: 2 },
      boxShadow: 'none',
      border: 1,
      borderColor: 'divider',
    }}
  >
    <AccordionSummary expandIcon={<ExpandMoreIcon />} sx={{ px: 3 }}>
      <Typography variant="subtitle1" fontWeight={600}>
        {title}
      </Typography>
    </AccordionSummary>
    <AccordionDetails sx={{ px: 3, pb: 4 }}>{children}</AccordionDetails>
  </Accordion>
);
